import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10 max-w-7xl mx-auto">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 group">
              <div className="w-9 h-9 bg-primary-500 rounded-lg flex items-center justify-center">
                <i className="ri-plant-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading font-bold text-lg text-background-50 whitespace-nowrap">
                黄瓜网站
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              聚焦黄瓜种植技术与市场行情，服务全国黄瓜种植户与经销商的专业信息平台。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 rounded-full bg-background-800 hover:bg-primary-500 flex items-center justify-center transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm text-background-200"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-full bg-background-800 hover:bg-primary-500 flex items-center justify-center transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm text-background-200"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-full bg-background-800 hover:bg-primary-500 flex items-center justify-center transition-colors cursor-pointer" aria-label="邮箱">
                <i className="ri-mail-line text-sm text-background-200"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">
              内容分类
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">
              热门内容
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/article/huanggua-gaochan-zaipei-jishu-yaodian" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">高产栽培技术要点</Link></li>
              <li><Link to="/article/huanggua-shuangmeibing-fangzhi-fangan" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">霜霉病防治方案</Link></li>
              <li><Link to="/article/2026-nian-xiabanian-huangguo-jiage-zoushi-yuce" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">价格走势预测</Link></li>
              <li><Link to="/article/huangguo-zhongzi-xuangou-zhinan" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">种子选购指南</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">
              联系我们
            </h4>
            <ul className="space-y-2.5">
              <li className="flex items-start gap-2 text-sm text-background-400">
                <i className="ri-phone-line mt-0.5 text-primary-400"></i>
                <span>400-888-9999</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-background-400">
                <i className="ri-mail-line mt-0.5 text-primary-400"></i>
                <span>contact@huanggua.site</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-background-400">
                <i className="ri-map-pin-line mt-0.5 text-primary-400"></i>
                <span>山东省潍坊市寿光蔬菜高科技示范园</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4 max-w-7xl mx-auto">
          <p className="text-xs text-background-500">
            &copy; 2026 黄瓜网站 huanggua.site 版权所有 | 
            <a href="#" className="hover:text-primary-400 transition-colors ml-1">京ICP备2024000001号</a>
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <a href="#" className="hover:text-primary-400 transition-colors">隐私政策</a>
            <a href="#" className="hover:text-primary-400 transition-colors">使用条款</a>
            <a href="#" className="hover:text-primary-400 transition-colors">网站地图</a>
          </div>
        </div>
      </div>
    </footer>
  );
}